import {
  companyHasSinglePermission,
  userHasAnyPermission,
  userHasSinglePermission,
} from 'util/PermissionsUtils';
import { Permission, Permission as P } from 'common/models/Permissions';

export const AllowClientsModule = () =>
  userHasSinglePermission(P.Clients) && companyHasSinglePermission(P.Clients);
export const AllowClientsAddEdit = () =>
  userHasSinglePermission(P.ClientsAddEdit) && companyHasSinglePermission(P.ClientsAddEdit);
export const AllowClientsDelete = () =>
  userHasSinglePermission(P.ClientsDelete) && companyHasSinglePermission(P.ClientsDelete);
export const AllowClientsReportsAccess = () => userHasSinglePermission(P.ClientsReports);
export const AllowClientsImport = () =>
  userHasAnyPermission([Permission.OfficeAdministrator, Permission.SystemAdministrator]);
